// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import GlobalStyles from '../../../config/styles';

const styles = theme => ({
  mainContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 50,
    [theme.breakpoints.down(500)]: {
      marginTop: 20,
    },
  },
  subContainer: {
    width: 630,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 10,
    [theme.breakpoints.down(750)]: {
      width: '90%',
    },
  },
  headerText: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MAX,
    color: GlobalStyles.color.COLOR_SECONDARY,
    textAlign: 'center',
  },
  text: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    color: GlobalStyles.color.COLOR_GREY,
    textAlign: 'center',
    marginTop: 20,
    marginBottom: 30,
  },
  statusText: {
    width: '50%',
    [theme.breakpoints.down(750)]: {
      width: '80%',
    },
  },
  rowContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down(750)]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  line: {
    width: '100%',
    height: 1,
    backgroundColor: 'grey',
  },
  getPaidText: {
    [theme.breakpoints.down(750)]: {
      maxWidth: '290px !important',
    },
    padding: '24px 0px',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    color: GlobalStyles.color.COLOR_GREY,
  },
  getPaidTextBold: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
  error: {
    margin: 5,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    color: GlobalStyles.color.COLOR_REJECT,
  },
  button: {
    marginTop: 28,
    marginBottom: 30,
  },
  withError: {
    marginTop: 10,
  },
  statusIcon: {
    width: 80,
    height: 80,
    marginTop: 50,
    [theme.breakpoints.down(750)]: {
      marginTop: 0,
    },
  },
});

export default styles;
